import * as React from 'react'

function SvgUa(props) {
	return (
		<svg viewBox="0 0 1200 800" width="1em" height="1em" {...props}>
			<path fill="#005BBB" d="M0 0h1200v800H0z" />
			<path fill="#FFD500" d="M0 400h1200v400H0z" />
		</svg>
	)
}

export default SvgUa
